module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"requiredField":"This field is required","finishTest":"Finish the testing section","enterTheAnswer":"Enter your answer"}}')
  delete Component.options._Ctor
}
